export default __webpack_public_path__ + "static/media/whatsappIcon.49b9869c.webp";